






import { Vue, Component } from 'vue-property-decorator'
import { Draggable, DraggableValue } from 'draggable-vue-directive'
import DragContainer from './components/DragContainer.vue'


@Component({
  directives: {
    Draggable,
  },
  components: {
    DragContainer,
  },
})
export default class App extends Vue {
  boxes = 0
  draggableWithHandler: DraggableValue = { handle: undefined }
  draggableWithBoundries: DraggableValue = {}
  draggableWithResetPosition: DraggableValue = { resetInitialPos: false }

}
